import { defineAdderChecks } from '@svelte-add/core';
import { options } from './options';

export const checks = defineAdderChecks({
	options,
});
